/**
 * TtfHeadTable.ts class for EJ2-PDF
 */
var TtfHeadTable = /** @class */ (function () {
    function TtfHeadTable() {
    }
    return TtfHeadTable;
}());
export { TtfHeadTable };
